import React from 'react';
import type { ImageSource } from '../../types/content';
export function ImageSourceBadge({
  source,
  className = ''
}: {
  source: ImageSource;
  className?: string;
}) {
  if (source !== 'representative') return null;
  return <span className={`pointer-events-none inline-flex items-center bg-charcoal-950/85 px-2 py-1 text-[11px] font-semibold uppercase tracking-[0.12em] text-steel-200 ${className}`} data-id="element-463" data-mp="1eqkzinjn4vd1">
      Representative image
    </span>;
}